import React from 'react'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import { AppBar, Toolbar } from '@mui/material'

import { UserRoleType } from '~api/models'
import { getUser } from '~store/account/selectors'
import { DrawerHandlingProps, DrawerStatusProps } from '~app/components/NavigationContainer/NavigationContainer'
import { useAppBarComponentStyles } from '~app/components/NavigationContainer/components/AppBarComponent/AppBarComponentStyles'

import LanguageSwitcher from './components/LanguageSwitcher'
import AccountMenu from './components/AccountMenu'
import DrawerHeaderOverlay
  from '~app/components/NavigationContainer/components/DrawerHeaderOverlay/DrawerHeaderOverlay'

type Props = DrawerStatusProps & DrawerHandlingProps

const AppBarComponent: React.FC<Props> = (props) => {
  const { drawerLarge, useHoverDrawer } = props
  const s = useAppBarComponentStyles()
  const user = useSelector(getUser)

  return <AppBar
    style={{
      position: 'fixed',
      top: 0,
    }}
    className={clsx(
      s.appBar,
      !useHoverDrawer && drawerLarge && s.appBarWhenDrawerLarge,
      !useHoverDrawer && !drawerLarge && s.appBarWhenDrawerSmall,
      (user?.role === UserRoleType.ADMINISTRATOR) && s.appBarAdmin,
    )}
    elevation={0}
  >
    <Toolbar className={s.appBarToolbar}>
      <DrawerHeaderOverlay {...props} />
      <AccountMenu />
      <LanguageSwitcher />
    </Toolbar>
  </AppBar>
}

export default AppBarComponent
